import React, { useEffect, useState } from "react";
import {
  Container,
  Box,
  Checkbox,
  Button,
  Divider,
  IconButton,
} from "@mui/material";
import "./TextScreen.css";
import logo from "../assets/logo.png";
import { getTextById } from "../api/text";
import CloseIcon from "@mui/icons-material/Close";

const TextScreen = ({ id }) => {
  const [text, setText] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const textRes = await getTextById(id);
      if (textRes.status === 200) {
        setText(textRes.data.content["es"]);
      }
    };
    fetchData();
  }, []);

  const closeWindow = () => {
    // Cierra la ventana actual
    window.close();
    // Regresa a la ventana principal
    if (window.opener) {
      window.opener.location.reload(); // Esto recarga la ventana principal, puedes cambiarlo según lo que necesites
    }
  };

  return (
    <Container className="container-fluid">
      <div className="header">
        {/* Logo */}
        <div className="logo-container mt-3">
          <img src={logo} alt="Tipify Logo" className="logo2" />
        </div>
        {/* Botón de cierre (X) */}
        <IconButton
          onClick={closeWindow}
          sx={{
            "& .MuiSvgIcon-root": {
              fontSize: "2.7rem !important",
              color: "black",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </div>
      <div dangerouslySetInnerHTML={{ __html: text }} />
    </Container>
  );
};

export default TextScreen;
